import React, { useState, useEffect, memo, useRef } from "react";
import { useTheme } from "@mui/material";

import { Box, Chip, CircularProgress, Grid, Typography } from "@mui/material";

import AccountCircle from "@mui/icons-material/AccountCircle";
import HistoryIcon from "@mui/icons-material/History";

import { useSelector, useDispatch } from "react-redux";
import { updateChatID } from "../redux/threadSlice";
// import { wsApiGateway } from "../constants/urls";

import logo from "../static/logo.png";
import VideoCard from "./VideoCard";

import { useSocket } from "../constants/useSocket";
import Carousel from "./Carousel";
import {
  updateFromStorylines,
  updateLoading,
  updateProgressMessage,
} from "../redux/querySlice";
import {
  decompress,
  isRouter,
  isChatMetaData,
  isVideoClip,
  isAlternateClip,
  isAgentText,
  isRelated,
  isHumanText,
  isStoryMetadata,
  isComplete,
  isOsDebugContext,
  isLlmCallContext,
  isAnswer,
  isStoryline,
  getErrorMessage,
  isVoiceOverVideoClip,
  isHCLiveStreamClip,
} from "./Messages";
import Storylines from "./Storylines";
import KeysegmentsAndStorylines from "./KeysegmentsAndStroylines";
import ResultsPlaybackComponent from "./ResultsPlaybackComponent";
import {
  toggleKeysegmentsAndStorylinesView,
  updateCurrentKeysegment,
  updateCurrentStoryline,
} from "../redux/keysegmentsAndStorylinesSlice";
import { useResultsNewHook } from "./useResultsNewHook";
import { startWebSocket } from "../redux/webSocketSlice";

const ResultsNew = memo((props) => {
  const theme = useTheme();
  let socket = useSocket();
  let videoSocket = useSocket();
  let storylineSocket = useSocket();
  let wsApiGateway = process.env.REACT_APP_WS_API_GATEWAY_BASE_URL;
  const {
    formatQueryText,
    convertBaseClip,
    convertVoiceOverAudioClip,
    convertVoiceOverOverlayClip,
    convertVoiceOverClip,
    convertPrimaryClip,
    convertAlternateClip,
    convert_history_clips,
    convertToStoryline,
  } = useResultsNewHook();

  const dispatch = useDispatch();
  const currentKeySegment = useSelector(
    (state) => state.keysegmentsAndStorylines.currentKeysegment
  );
  const currentStoryline = useSelector(
    (state) => state.keysegmentsAndStorylines.currentStoryline
  );
  const showStorylinesComponent = useSelector(
    (state) => state.keysegmentsAndStorylines.showStorylinesComponent
  );
  const currentThreadID = useSelector((state) => state.activeChatID.value);
  const currentThreadIDRef = useRef(currentThreadID);
  const queryStartDate = useSelector((state) => state.queryText.startDate);
  const queryEndDate = useSelector((state) => state.queryText.endDate);
  const queryType = useSelector((state) => state.queryText.queryType);
  const storylineStartDate = useSelector(
    (state) => state.queryText.storylineStartDate
  );
  const storylineEndDate = useSelector(
    (state) => state.queryText.storylineEndDate
  );
  const fromStorylines = useSelector((state) => state.queryText.fromStorylines);
  const storylineChatId = useSelector(
    (state) => state.queryText.storylineChatId
  );
  const dateRangeStartTime = useSelector((state) => state.dateRange.startDate);
  const dateRangeEndTime = useSelector((state) => state.dateRange.endDate);
  const prompts = useSelector((state) => state.prompts.value);
  const queryTextRedux = useSelector((state) => state.queryText.value);
  const progressMessage = useSelector(
    (state) => state.queryText.progressMessage
  );
  const isWebSocketActive = useSelector(
    (state) => state.webSocket.isWebSocketActive
  );

  const [videoSocketInstance, setVideoSocketInstance] = useState(null);
  const [storylinesSocketInstance, setStorylinesSocketInstance] =
    useState(null);
  const [socketResults, setSocketResults] = useState([]);
  const [agentText, setAgentText] = useState("");
  const [answerText, setAnswerText] = useState("");
  const [chatId, setChatId] = useState("");
  const [startThread, setStartThread] = useState(false);
  const startThreadRef = useRef(startThread);
  const [relatedContent, setRelatedContent] = useState([]);
  const [storyMetadata, setStoryMetadata] = useState([]);
  const [socketComplete, setSocketComplete] = useState(false);
  const [storylineSocketComplete, setStorylineSocketComplete] = useState(false);
  const [socketError, setSocketError] = useState("");
  const [debugMessages, setDebugMessages] = useState([]);
  const [isQA, setIsQA] = useState(false);
  const [routeType, setRouteType] = useState("");
  const [voiceOver, setVoiceOver] = React.useState(false);
  const [voiceOverResults, setVoiceOverResults] = useState([]);
  const [storyLineResults, setStoryLineResults] = useState([]);
  const [keySegments, setKeySegments] = useState([]);
  const [videoCompilation, setVideoCompilation] = useState([]);
  const [isVideoStory, setIsVideoStory] = useState(false);
  const [isCurationCancelled, setIsCurationCancelled] = useState(false);

  const resetValues = () => {
    setSocketResults([]);
    setAgentText("");
    setAnswerText("");
    setRelatedContent([]);
    setStoryMetadata([]);
    setSocketComplete(false);
    setStorylineSocketComplete(false);
    dispatch(updateProgressMessage(""));
    setDebugMessages([]);
    setIsQA(false);
    setRouteType("");
    setVoiceOver(false);
    setVoiceOverResults([]);
    setStoryLineResults([]);
    setKeySegments([]);
    setVideoCompilation([]);
    setIsVideoStory(false);
  };

  const newChatThread = (id) => {
    setChatId(id);
    setStartThread(true);
    dispatch(updateChatID(id));
    // window.history.pushState("", "", "/q/" + id + "/story");
  };

  const openSocket = () => {
    socket = new WebSocket(wsApiGateway);
    setVideoSocketInstance(socket);
  };

  // const openVideoStorySocket = () => {
  //   videoSocket = new WebSocket(wsApiGateway);
  //   setVideoSocketInstance(socket);
  // };

  const openStorylinesSocket = () => {
    storylineSocket = new WebSocket(wsApiGateway);
    setStorylinesSocketInstance(storylineSocket);
  };

  const sendMsg = (e) => {
    if (socket.readyState === 1) {
      console.log("connection is established: ", socket.readyState);
      socket.send(e);
      if (e?.capability) {
        handleStorylinesAndKeysegmentsMsg();
      } else {
        handleMsg();
      }
    } else {
      console.log("websocket connection state: ", socket.readyState);
      setTimeout(function () {
        sendMsg(e);
      }, 1500);
    }
  };

  const sendStorylineMsg = (e) => {
    if (storylineSocket.readyState === 1) {
      console.log("connection is established: ", storylineSocket.readyState);
      storylineSocket.send(e);
      handleStorylinesAndKeysegmentsMsg();
    } else {
      console.log(
        "webstorylineSocket connection state: ",
        storylineSocket.readyState
      );
      setTimeout(function () {
        sendStorylineMsg(e);
      }, 1500);
    }
  };

  const handleMsg = () => {
    // dispatch(updateLoading(true));
    if (queryType === "chatQuery" || queryType === "storylineQuery") {
      dispatch(updateLoading(true));
    } else {
      dispatch(updateLoading(false));
    }
    socket.onmessage = (data) => {
      let thisMessage = decompress(JSON.parse(data.data));
      let thisMessageSeq;
      let voiceOverMessageSeq;

      if (thisMessage && isChatMetaData(thisMessage) && !startThread) {
        newChatThread(thisMessage["chat_id"]);
      }

      if (isRouter(thisMessage)) {
        setRouteType(thisMessage["route"]);
        if (thisMessage["route"] === "question_answering") {
          dispatch(updateProgressMessage("Answering your query..."));
          dispatch(toggleKeysegmentsAndStorylinesView(true));
          if (queryType === "chatQuery") {
            setStoryLineResults([]);
            setKeySegments([]);
            setTimeout(() => {
              askSmith("key_moment_and_storyline_generation");
            }, 1000);
          }
        }

        if (thisMessage["route"] === "story_generation") {
          setIsVideoStory(true);
          dispatch(updateProgressMessage("Curating your story..."));
          dispatch(toggleKeysegmentsAndStorylinesView(true)); // switch to video stories view and fetch storylines
          if (queryType === "chatQuery") {
            setStoryLineResults([]);
            setKeySegments([]);
            setTimeout(() => {
              askSmith("key_moment_and_storyline_generation");
            }, 1000);
          }
        }

        if (thisMessage["route"] === "voiceover_generation") {
          dispatch(updateProgressMessage("Curating your voiceover story..."));
          dispatch(toggleKeysegmentsAndStorylinesView(true)); // switch to video stories view and fetch storylines
          if (queryType === "chatQuery") {
            setStoryLineResults([]);
            setKeySegments([]);
            setTimeout(() => {
              askSmith("key_moment_and_storyline_generation");
            }, 1000);
          }
        }

        if (thisMessage["route"] === "holistic_voiceover_generation") {
          dispatch(updateProgressMessage("Curating your voiceover story..."));
          dispatch(toggleKeysegmentsAndStorylinesView(true));
          if (queryType === "chatQuery") {
            setStoryLineResults([]);
            setKeySegments([]);
            setTimeout(() => {
              askSmith("key_moment_and_storyline_generation");
            }, 1000);
          }
        }

        if (thisMessage["route"] === "storyline_generation") {
          // dispatch(updateProgressMessage("Curating storylines..."));
        }

        if (thisMessage["route"] === "analysis_generation") {
          dispatch(updateProgressMessage("Curating analysis style story..."));
          dispatch(toggleKeysegmentsAndStorylinesView(true)); // switch to video stories view and fetch storylines
          if (queryType === "chatQuery") {
            setStoryLineResults([]);
            setKeySegments([]);
            setTimeout(() => {
              askSmith("key_moment_and_storyline_generation");
            }, 1000);
          }
        }
        if (thisMessage["route"] === "editing_generation") {
          dispatch(updateProgressMessage("Editing your story..."));
          dispatch(toggleKeysegmentsAndStorylinesView(true));
        }

        if (
          thisMessage["route"] === "key_moment_and_storyline_generation" &&
          queryType === "feedQuery"
        ) {
          dispatch(toggleKeysegmentsAndStorylinesView(false));
        }

        if (thisMessage["route"] === "interview_extraction_capability") {
          setIsVideoStory(true);
          dispatch(updateProgressMessage("Extracting interview..."));
          dispatch(toggleKeysegmentsAndStorylinesView(true)); // switch to video stories view and fetch storylines
          if (queryType === "chatQuery") {
            setStoryLineResults([]);
            setKeySegments([]);
            setTimeout(() => {
              askSmith("key_moment_and_storyline_generation");
            }, 1000);
          }
        }
      }

      if (isChatMetaData(thisMessage)) {
        dispatch(updateProgressMessage(""));
      }

      if (isVideoClip(thisMessage)) {
        // dispatch(updateProgressMessage("Curating video clips..."));
        thisMessageSeq = convertPrimaryClip(thisMessage);
        setSocketResults(
          Array.isArray(socketResults) && socketResults?.push(thisMessageSeq)
        );
        setVideoCompilation((compilation) => [...compilation, thisMessageSeq]);
      } else if (isVoiceOverVideoClip(thisMessage)) {
        setVoiceOver(true);
        // dispatch(updateProgressMessage("Curating video clips..."));
        voiceOverMessageSeq = convertVoiceOverClip(thisMessage);
        setVoiceOverResults(
          Array.isArray(voiceOverResults) &&
            voiceOverResults?.push(voiceOverMessageSeq)
        );
      } else if (isStoryline(thisMessage)) {
        let storyline = convertToStoryline(thisMessage);
        // setSocketResults((socketResults) => [...socketResults, storyline]);
        setVoiceOverResults((voiceOverResults) => [
          ...voiceOverResults,
          storyline,
        ]);
        setStoryLineResults((storyLineResults) => [
          ...storyLineResults,
          storyline,
        ]);
      } else if (isAlternateClip(thisMessage)) {
        // dispatch(updateProgressMessage("Curating alternate clips..."));
        thisMessageSeq = convertAlternateClip(thisMessage);
        voiceOverMessageSeq = convertAlternateClip(thisMessage);
        if (socketResults.length > 0) {
          var found = false;
          for (var i = 0; i < socketResults.length; i++) {
            if (socketResults[i].id === thisMessageSeq.id) {
              socketResults[i].alternate_clips.push(thisMessageSeq);
              break;
            }
          }
          if (found) {
            setSocketResults(socketResults);
          }
        }
        if (voiceOverResults.length > 0) {
          var found = false;
          for (var i = 0; i < voiceOverResults.length; i++) {
            if (voiceOverResults[i].id === voiceOverMessageSeq.id) {
              voiceOverResults[i].alternate_clips.push(voiceOverMessageSeq);
              break;
            }
          }
          if (found) {
            setVoiceOverResults(voiceOverResults);
          }
        }
      } else if (isAgentText(thisMessage)) {
        setAgentText(thisMessage["text"]);
      } else if (isRelated(thisMessage)) {
        setRelatedContent((relatedContent) => [...relatedContent, thisMessage]);
      } else if (isStoryMetadata(thisMessage)) {
        setStoryMetadata(thisMessage);
        // if (showStorylinesComponent && queryType === "chatQuery") {
        if (queryType === "chatQuery") {
          let videoStory = {
            id: thisMessage?.message_id,
            text: thisMessage?.title,
            voiceOverStory: isVideoStory ? false : true, // to detect behaviour in storylines
            videoStory: isVideoStory ? true : false, // to detect behaviour in storylines
            start_time: thisMessage?.create_time,
            end_time: thisMessage?.create_time,
          };
          setStoryLineResults((storyLineResults) => [
            videoStory,
            ...storyLineResults,
          ]);
        }
      } else if (isAnswer(thisMessage)) {
        setAgentText(thisMessage["answer"]);
        setAnswerText(thisMessage["answer"]);
        setIsQA(true);
        dispatch(updateProgressMessage("Loading reference videos..."));
        thisMessage["reference_clips"].forEach((refClip) => {
          // setSocketResults(socketResults.push(convertBaseClip(refClip)));
          // setVideoCompilation(videoCompilation.push(convertBaseClip(refClip)));
          setVideoCompilation((compilation) => [...compilation, refClip]);
          setVoiceOverResults(
            Array.isArray(voiceOverResults) &&
              voiceOverResults?.push(convertBaseClip(refClip))
          );
        });
        let qna = {
          // id: thisMessage?.chat_id,
          id: `${thisMessage?.chat_id}-${Math.floor(Math.random() * 1000)}`, //generate unique id
          text: queryTextRedux,
          isQA: true,
          start_time: thisMessage?.create_time,
          end_time: thisMessage?.create_time,
        };
        setStoryLineResults((storyLineResults) => [qna, ...storyLineResults]);
      } else if (
        isOsDebugContext(thisMessage) ||
        isLlmCallContext(thisMessage)
      ) {
        setDebugMessages((debugMessages) => [...debugMessages, thisMessage]);
      } else if (isComplete(thisMessage)) {
        dispatch(updateProgressMessage(""));
        dispatch(updateLoading(false));
        socket.close();
        setSocketComplete(true);
      } else if (getErrorMessage(thisMessage)) {
        dispatch(updateLoading(false));
        dispatch(updateProgressMessage("Sorry, an error has occurred."));
        setAgentText(getErrorMessage(thisMessage));
        setSocketError(getErrorMessage(thisMessage));
        setSocketComplete(true);
      } else if (isStoryline(thisMessage)) {
        dispatch(updateProgressMessage("Curating storylines..."));
      } else if (isHCLiveStreamClip(thisMessage)) {
        dispatch(updateProgressMessage("Finding key segments..."));
        setKeySegments((keySegments) => [...keySegments, thisMessage]);
      } else {
        setSocketResults(socketResults);
        setVoiceOverResults(voiceOverResults);
        // setVideoCompilation(videoCompilation);
      }
    };
  };

  const handleStorylinesAndKeysegmentsMsg = () => {
    storylineSocket.onmessage = (data) => {
      let thisMessage = decompress(JSON.parse(data.data));

      if (isStoryline(thisMessage)) {
        let storyline = convertToStoryline(thisMessage);
        setStoryLineResults((storyLineResults) => [
          ...storyLineResults,
          storyline,
        ]);
        dispatch(updateProgressMessage("Curating storylines..."));
      } else if (isHCLiveStreamClip(thisMessage)) {
        dispatch(updateProgressMessage("Finding key segments..."));
        setKeySegments((keySegments) => [...keySegments, thisMessage]);
      } else if (isComplete(thisMessage)) {
        dispatch(updateProgressMessage(""));
        // dispatch(updateLoading(false));
        storylineSocket.close();
        setStorylineSocketComplete(true);
      } else if (getErrorMessage(thisMessage)) {
        // dispatch(updateLoading(false));
        dispatch(updateProgressMessage("Sorry, an error has occurred."));
        setAgentText(getErrorMessage(thisMessage));
        setSocketError(getErrorMessage(thisMessage));
        setStorylineSocketComplete(true);
      }
    };
  };

  const askSmith = (capability = null) => {
    dispatch(startWebSocket());
    let msg;
    let prompts_str = JSON.stringify(prompts);

    let msg_dict = {
      action: "get-chat-response",
      user_id: sessionStorage.getItem("username"),
      query: props.queryText,
    };
    if (capability) {
      msg_dict["capability"] = capability;
    }
    if (queryType === 'chatQuery') {
      msg_dict['query_source'] = 'USER_QUERY';
    } else {
      msg_dict['query_source'] = 'FEED';
    }

    if (queryType === "topicQuery" || queryType === "feedQuery") {
      msg_dict["capability"] = "key_moment_and_storyline_generation";
    }
    // if (!startThread && currentThreadID.length < 8) {
    if (!startThreadRef.current && currentThreadIDRef.current.length < 8) {
      console.log("New Thread");
    } else {
      console.log("Existing Thread");
      // don't send chatID when clicking on feed
      if (queryType !== "feedQuery") {
        msg_dict["chat_id"] = currentThreadIDRef.current;
      }
    }

    if (fromStorylines) {
      msg_dict["start_time"] =
        storylineStartDate > 0
          ? storylineStartDate
          : dateRangeStartTime || null;
      msg_dict["end_time"] =
        storylineEndDate > 0 ? storylineEndDate : dateRangeEndTime || null;
    }

    msg = JSON.stringify(msg_dict);

    if (socket.readyState > 1) {
      console.log(
        "WebSocket connection is not OPEN, it is: ",
        socket.readyState
      );
      if (capability) openStorylinesSocket();
      // else openVideoStorySocket();
      else openSocket();
      setRouteType("");
      setIsQA(false);
      sendMsg(msg);
      dispatch(updateFromStorylines(false));
    } else {
      if (capability) openStorylinesSocket();
      // else openVideoStorySocket();
      else openSocket();
      setRouteType("");
      setIsQA(false);
      if (capability) {
        sendStorylineMsg(msg);
      } else {
        sendMsg(msg);
      }
      if (capability) {
        handleStorylinesAndKeysegmentsMsg();
      } else {
        handleMsg();
      }
      dispatch(updateFromStorylines(false));
    }
  };

  useEffect(() => {
    startThreadRef.current = startThread;
  }, [startThread]);

  useEffect(() => {
    currentThreadIDRef.current = currentThreadID;
  }, [currentThreadID]);

  useEffect(() => {
    setIsCurationCancelled(false);
    if (
      !props.isHistory ||
      (props.isHistory &&
        props.addToHistory &&
        Object.keys(props.activityLog).length > 0 &&
        props.queryText.length > 0)
    ) {
      // if (socketInstance) {
      //   socketInstance.close();
      // }
      if (videoSocketInstance) {
        videoSocketInstance.close();
      }
      askSmith();
    }
  }, [props.queryText]);

  useEffect(() => {
    if (keySegments?.length > 0) {
      dispatch(updateCurrentKeysegment(keySegments[0]));
    }
  }, [keySegments]);

  useEffect(() => {
    if (queryType === "feedQuery" && startThread === true) {
      setStartThread(false);
    }
    if (
      (queryType === "storylineQuery" || queryType === "chatQuery") &&
      showStorylinesComponent
    ) {
      setSocketComplete(false);
      setSocketResults([]);
      setVideoCompilation([]);
      setAnswerText("");
      setVoiceOverResults([]);
      setAgentText("");
      setSocketError("");
      if (queryType === "chatQuery") dispatch(updateCurrentStoryline(null));
    } else {
      resetValues();
      setSocketError("");
      dispatch(updateCurrentKeysegment(null));
      dispatch(updateCurrentStoryline(null));
    }
  }, [queryTextRedux, queryType]);

  useEffect(() => {
    if (!isWebSocketActive) {
      videoSocketInstance && videoSocketInstance.close();
      storylinesSocketInstance && storylinesSocketInstance.close();
      setIsCurationCancelled(true);
    }
  }, [isWebSocketActive]);

  return (
    <Box className="results-new-wrapper">
      {props.isHistory === true ? (
        <div>
          <Chip
            label="From your recent activity"
            sx={{ mb: 2 }}
            icon={<HistoryIcon />}
          />
          {props.activityLog &&
            props.activityLog.map((item) => {
              // map through whole activity log and group by message_id
              let collection = [];
              let altCollection = [];
              let routeType = "";
              let agentText = "";
              let historyQueryText = "";
              let storyMetadata = [];
              let qaCollection = [];
              {
                /* console.log("key: ", key);
            console.log("key group object: ", props.activityLog[key]); */
              }

              item.map((message) => {
                // check message type
                if (isHumanText(message)) {
                  historyQueryText = message["text"];
                }
                if (isRouter(message)) {
                  routeType = message.route;
                }
                if (isStoryline(message)) {
                  collection.push(message);
                }
                if (isAlternateClip(message)) {
                  altCollection.push(message);
                }
                if (isVideoClip(message)) {
                  collection.push(message);
                }
                if (isAgentText(message)) {
                  agentText = message.agentText;
                }
                if (isAnswer(message)) {
                  qaCollection.push(message["reference_clips"]);
                }
                if (isStoryMetadata(message)) {
                  storyMetadata = message;
                }
              });
              if (routeType === "storyline_generation") {
                // render storyline
                return (
                  <>
                    <div
                      style={{
                        display: "flex",
                        alignItems: "center",
                        fontWeight: 600,
                        color: "#666666",
                      }}
                    >
                      <AccountCircle
                        sx={{
                          color: "#666666",
                          fontSize: "28px",
                          marginRight: "4px",
                        }}
                      />
                      {historyQueryText}
                    </div>

                    <div
                      style={{
                        display: "flex",
                        alignItems: "flex-start",
                        marginTop: 12,
                        marginBottom: 48,
                      }}
                    >
                      <div
                        style={{
                          display: "flex",
                          alignItems: "top",
                          marginTop: 4,
                          marginBottom: 12,
                          fontSize: 16,
                          fontWeight: 700,
                          color: "#AC1FFF",
                        }}
                      >
                        <img
                          src={logo}
                          width={24}
                          alt="logo"
                          style={{ marginRight: "10px" }}
                        />
                      </div>
                      <Storylines
                        // query={historyQueryText}
                        stories={collection}
                        agentText={agentText}
                        debug_messages={debugMessages}
                      />
                    </div>
                  </>
                );
              } else if (routeType === "question_answering") {
                return (
                  <>
                    <div
                      style={{
                        display: "flex",
                        alignItems: "center",
                        fontWeight: 600,
                        color: "#666666",
                      }}
                    >
                      <AccountCircle
                        sx={{
                          color: "#666666",
                          fontSize: "28px",
                          marginRight: "4px",
                        }}
                      />
                      {historyQueryText}
                    </div>
                    <div
                      style={{
                        display: "flex",
                        alignItems: "flex-start",
                        marginTop: 12,
                        marginBottom: 48,
                      }}
                    >
                      <div
                        style={{
                          display: "flex",
                          alignItems: "top",
                          marginTop: 4,
                          marginBottom: 12,
                          fontSize: 16,
                          fontWeight: 700,
                          color: "#AC1FFF",
                        }}
                      >
                        <img
                          src={logo}
                          width={24}
                          alt="logo"
                          style={{ marginRight: "10px" }}
                        />
                      </div>
                      <VideoCard
                        compilation={qaCollection}
                        isQA={true}
                        storyMetadata={storyMetadata}
                      />
                    </div>
                  </>
                );
              } else {
                // render other videocard options (q&a, editing, analysis, story)
                return (
                  <>
                    <div
                      style={{
                        display: "flex",
                        alignItems: "center",
                        fontWeight: 600,
                        color: "#666666",
                      }}
                    >
                      <AccountCircle
                        sx={{
                          color: "#666666",
                          fontSize: "28px",
                          marginRight: "4px",
                        }}
                      />
                      {historyQueryText}
                    </div>
                    <div
                      style={{
                        display: "flex",
                        alignItems: "flex-start",
                        marginTop: 12,
                        marginBottom: 48,
                      }}
                    >
                      <div
                        style={{
                          display: "flex",
                          alignItems: "top",
                          marginTop: 4,
                          marginBottom: 12,
                          fontSize: 16,
                          fontWeight: 700,
                          color: "#AC1FFF",
                        }}
                      >
                        <img
                          src={logo}
                          width={24}
                          alt="logo"
                          style={{ marginRight: "10px" }}
                        />
                      </div>
                      <VideoCard
                        compilation={collection}
                        socketComplete={true}
                        message="Curation complete"
                        storyMetadata={storyMetadata}
                      />
                    </div>
                  </>
                );
              }
            })}

          {props.addToHistory === true && props.queryText.length > 1 && (
            <div>
              <div
                style={{
                  display: "flex",
                  alignItems: "center",
                  fontWeight: 600,
                  color: "#666666",
                }}
              >
                <AccountCircle
                  sx={{
                    color: "#666666",
                    fontSize: "28px",
                    marginRight: "4px",
                  }}
                />
                {formatQueryText(props.queryText)}
              </div>

              <div
                style={{
                  display: "flex",
                  alignItems: "flex-start",
                  marginTop: 12,
                }}
              >
                <div
                  style={{
                    display: "flex",
                    alignItems: "top",
                    marginTop: 4,
                    marginBottom: 12,
                    fontSize: 16,
                    fontWeight: 700,
                    color: "#AC1FFF",
                  }}
                >
                  <img src={logo} width={24} style={{ marginRight: "10px" }} />
                </div>
                <div style={{ width: "100%" }}>
                  <VideoCard
                    compilation={videoCompilation}
                    theme={props.theme}
                    agentText={agentText}
                    answerText={answerText}
                    isQA={isQA}
                    storyMetadata={storyMetadata}
                    socketComplete={socketComplete}
                    open_alt_clips_panel={props.open_alt_clips_panel}
                    alt_clips_drawer={props.alt_clips_drawer}
                    open_debug_panel={props.open_debug_panel}
                    debug_drawer={props.debug_drawer}
                    debug_messages={debugMessages}
                    message={progressMessage}
                  />
                  <Carousel
                    items={relatedContent}
                    socketComplete={socketComplete}
                  />
                </div>
              </div>
            </div>
          )}
        </div>
      ) : props.queryText !== "" ? (
        <Box className="flex-center" gap="2rem" height="81vh">
          <ResultsPlaybackComponent
            socketResults={videoCompilation}
            currentKeySegment={currentKeySegment}
            answerText={answerText}
            agentText={agentText}
            isQA={isQA}
            storyMetadata={storyMetadata}
            socketComplete={socketComplete}
            open_alt_clips_panel={props.open_alt_clips_panel}
            alt_clips_drawer={props.alt_clips_drawer}
            open_debug_panel={props.open_debug_panel}
            debug_drawer={props.debug_drawer}
            debug_messages={debugMessages}
            progressMessage={progressMessage}
            socketError={socketError}
            isCurationCancelled={isCurationCancelled}
          />
          <KeysegmentsAndStorylines
            keySegments={keySegments}
            currentKeySegment={currentKeySegment}
            queryText={props.queryText}
            storyLines={storyLineResults}
            progressMessage={progressMessage}
            agentText={agentText}
            debugMessages={debugMessages}
            socketComplete={socketComplete}
            voiceOver={voiceOver}
            isQA={isQA}
            compilation={videoCompilation}
            answerText={answerText}
            isCurationCancelled={isCurationCancelled}
          />
        </Box>
      ) : null}
    </Box>
  );
});

export default ResultsNew;
